import { useEffect, useState } from 'react'
import { search } from '../lib/notes.js'

export default function Search() {
  const [q, setQ] = useState('')
  const [res, setRes] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (q.trim().length < 2) {
      setRes(null)
      return undefined
    }
    /* Wait for him to stop typing rather than querying every keystroke. */
    const id = setTimeout(async () => {
      try {
        setError(null)
        setRes(await search(q))
      } catch (e) {
        setError(e.message || String(e))
      }
    }, 250)
    return () => clearTimeout(id)
  }, [q])

  const groups = res
    ? [
        { label: 'Notes', rows: res.entries, text: (r) => r.body },
        { label: 'Tasks', rows: res.tasks, text: (r) => r.body },
        { label: 'Projects', rows: res.projects, text: (r) => r.title },
      ].filter((g) => g.rows.length)
    : []

  return (
    <>
      <div className="page-head">
        <span className="lbl">Search</span>
        <h1 className="serif">Find anything</h1>
      </div>

      <div className="field">
        <input
          id="search-q"
          type="search"
          placeholder="Search notes, tasks and projects"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          autoComplete="off"
        />
      </div>

      {error ? <div className="notice warn"><p style={{ margin: 0, fontSize: 14 }}>{error}</p></div> : null}

      {res && groups.length === 0 ? (
        <div className="empty">
          <h2 className="serif">Nothing found</h2>
          <p>No match for “{q.trim()}”.</p>
        </div>
      ) : null}

      {groups.map((g) => (
        <div key={g.label}>
          <p className="lbl" style={{ margin: '18px 2px 8px' }}>{g.label}</p>
          <div className="card">
            <div className="rows">
              {g.rows.map((r) => (
                <div className="row" key={r.id}>
                  <div className="nm"><b>{g.text(r)}</b></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </>
  )
}
